import { getDefaultExportFromCjs } from '../../../../_virtual/_commonjsHelpers.js';
import { b as bind$1 } from '../../full/instance/bind.js';

var bind = bind$1;

var _bindInstanceProperty = /*@__PURE__*/getDefaultExportFromCjs(bind);

export { _bindInstanceProperty as default };
//# sourceMappingURL=bind.js.map
